import { useCustomMutation } from '@mutations/index';
import config from '../../config';
import { METHODS } from '../constants';
import { useCallback } from 'react';

export const useCheckTaxRatesToChangeAfterObligationUpdate = () => {
  type CheckTaxEntriesToUpdateParams = {
    companyCode: string,
    countryCode: string,
    countryTaxType: string,
    deferredTaxRate: number
  }[];
  const { mutateAsync, isLoading } = useCustomMutation<
    {
      taxRatesToUpdate: number,
      unapprovedEntryCount: number,
    },
    Error,
    CheckTaxEntriesToUpdateParams
    >({
      handleData: (obligations: CheckTaxEntriesToUpdateParams) => ({
        method: METHODS.POST,
        url: config.endpoints.OBLIGATIONS_CHECK_TAX_RATES_TO_UPDATE,
        body: obligations,
      }),
      parseResponseAsJson: true,
      errorMessage: 'Failed to check tax rates to change',
      invalidateKey: [],
    });

  const checkTaxRatesToUpdate = useCallback(async (obligations: CheckTaxEntriesToUpdateParams) => {
    const { taxRatesToUpdate, unapprovedEntryCount } = await mutateAsync(obligations);
    return { taxRatesToUpdate, unapprovedEntryCount };
  }, [mutateAsync]);

  return { checkTaxRatesToUpdate, isLoading };
};

